import api from "./api";

const API_URL = "/task";

export const tasksService = {
  /**
   * Fetch all tasks. 
   * @param {number|null} groupId - If provided, fetches group tasks. Otherwise, personal tasks.
   */
  async getAllTasks(groupId = null) {
    // We send group_id as a query parameter if it exists
    const config = groupId ? { params: { group_id: groupId } } : {};
    const res = await api.get(API_URL, config);
    return res.data;
  },

  /**
   * Add a new task (Personal or Group)
   * @param {string} title 
   * @param {string} status 
   * @param {string} startDate 
   * @param {number|null} groupId - Pass the ID of the group if it's a team task
   */
  async addTask(formData ) {
    // Include group_id in the request body
    const res = await api.post(API_URL, formData );
    return res.data;
  },

  async updateTask(id, updatedData) {
    const res = await api.put(`${API_URL}/${id}`, updatedData);
    return res.data;
  },

  async deleteTask(id) {
    const res = await api.delete(`${API_URL}/${id}`);
    return res.data;
  },

  // --- Push Notification Methods ---
  
  async getTaskNotification() {
    const res = await api.get("/notifications");
    return res.data;
  },

  async saveSubscription(subscription) {
    return api.post(`${API_URL}/subscribe`, { subscription });
  },

  async unsubscribe(endpoint) {
    return api.delete(
      `${API_URL}/unsubscribe/${encodeURIComponent(endpoint)}`
    );
  },

  async testNotification() {
    return api.post(`${API_URL}/test-push`);
  },

  async checkServerSubscription() {
    const res = await api.get(`${API_URL}/subscribe-status`);
    return res.data.isSubscribed;
  },

  async unsubscribeUser() {
    try {
      const res = await api.post(`${API_URL}/unsubscribe-user`, {}, {
        withCredentials: true,  
      });
      return res.data;
    } catch (err) {
      throw err;
    }
  },


  // --- New: Comments Methods ---

  /**
   * @param {number} taskId 
   */
  async getTaskComments(taskId) {
    try {
      const res = await api.get(`${API_URL}/comments/${taskId}`);
      return res.data;
    } catch (err) {
      throw err;
    }
  },

  /**
   * @param {number} taskId 
   * @param {string} content 
   */
  async addComment(commentData) {
    try {
      const res = await api.post(`${API_URL}/comments`, commentData);
      return res.data;
    } catch (err) {
      throw err;
    }
  },
  async deleteComment(commentId) {
    const res = await api.delete(`${API_URL}/comments/${commentId}`);
    return res.data;
  },
  // get the gimini response for analyzing our data
  async analyzeTask(formData) {
    const res = await api.post(`${API_URL}/analyze`,{formData});
    return res.data;
  }

};
